import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DriverCommerceStatus, ProductDetail } from '../../driver-commerce-dto';
import { CommerceService } from 'app/services/commerce.service';
import { MessageService } from 'primeng/api';
import * as moment from 'moment';
import { CONFIRM_INPUT } from './edit-availed-product-confirm';

@Component({
  selector: 'edit-availed-product-confirm',
  standalone: false,
  templateUrl: './edit-availed-product-confirm.component.html',
  styleUrl: './edit-availed-product-confirm.component.scss'
})
export class EditAvailedProductConfirmComponent implements OnInit {

  @Input() visible: boolean = false;
  @Input() product!: ProductDetail;
  @Input() commerceId: number = 0;
  @Output() hideConfirmProduct = new EventEmitter<boolean>();
  @Output() backToDialog = new EventEmitter<boolean>();

  constructor(
      private commerceService: CommerceService,
      private messageService: MessageService
  ){}

  public dateToday = new Date();
  public availedDetails: any;
  public confirmInput: any;

  public warningMessage: string = '';
  public selectedStatus: any;
  public loading: boolean = false;
  public productComputation: any;


  ngOnInit(): void {
    if(this.commerceService.availedProductStatus){
      this.selectedStatus = this.commerceService.availedProductStatus;
      this.confirmInput = CONFIRM_INPUT[this.commerceService.availedProductStatus];
      this.warningMessage = CONFIRM_INPUT[this.commerceService.availedProductStatus].info;
      if(this.selectedStatus === 'Resume'){
        this.getPreResumeComputation();
      }
    }

    if(this.commerceService.availedProductDetails){
      this.availedDetails = this.commerceService.availedProductDetails;
    }
  }

  public getStatusText(status: any): string {
      let statusText = '';
      switch (status) {
        case DriverCommerceStatus.PendingTopup:
            statusText = 'Pending Top-up';
            break;
        case DriverCommerceStatus.PendingRelease:
          statusText = 'Pending Release';
            break;
        case DriverCommerceStatus.Active:
          statusText = 'Active';
            break;
        case DriverCommerceStatus.Paused:
          statusText = 'Paused';
            break;
        case DriverCommerceStatus.Suspended:
          statusText = 'Suspended';
            break;
        case DriverCommerceStatus.Cancelled:
          statusText = 'Cancelled';
            break;
        case DriverCommerceStatus.Completed:
          statusText = 'Completed';
            break;
        default:
          statusText = '';
      }
      return statusText;
  }

  hideDialog(){
    this.commerceService.resetAvailedProductsEdit();
    this.hideConfirmProduct.emit(false);
  }

  back(){
    this.backToDialog.emit(true);
  }

  checkCommerce(){
    switch(this.selectedStatus){
      case 'Paused':
        this.pauseCommerce();
        break;
      case 'Resume':
        this.resumeCommerce();
        break;
      default:
        break;
    }
  }


  pauseCommerce() {
    const now = moment.utc().add(8, 'hour');
      const dto = {
          CommerceId: this.commerceId,
          DatePause: moment(this.availedDetails.selectedDate).format('YYYY-MM-DDTHH:mm:ss'),
          TimeZoneOffset: 8,
          Reason: this.availedDetails.reason !== 'Others' ? this.availedDetails.reason : this.availedDetails.reason + ' - ' + this.availedDetails.specificReason,
          Remarks: this.availedDetails.remarks ? this.availedDetails.remarks : ''
      };
      this.commerceService.pauseCommerce(dto, this.messageService)
          .then(data => {
              if (!data.Success) {
                  this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                  return;
              }
              this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Successfully Paused' });
              this.hideConfirmProduct.emit(false);
          })
          .catch(err => {
              throw err;
          });
  }

  resumeCommerce() {
      const now = moment.utc().add(8, 'hour');
      const dto = {
          CommerceId: this.commerceId,
          ResumeDate: moment(this.availedDetails.selectedDate).format('YYYY-MM-DDTHH:mm:ss'),
          TimeZoneOffset: 8,
          Reason: this.availedDetails.reason !== 'Others' ? this.availedDetails.reason : this.availedDetails.reason + ' - ' + this.availedDetails.specificReason,
          Remarks: this.availedDetails.remarks ? this.availedDetails.remarks : ''
      };
      this.commerceService.resumeCommerce(dto, this.messageService)
          .then(data => {
              if (!data.Success) {
                  this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                  return;
              }
              this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Successfully Resumed' });
              this.hideConfirmProduct.emit(false);
          })
          .catch(err => {
              throw err;
          });
  }

  public getPreResumeComputation(): void {
    this.loading = true;
    const dto = {
        CommerceId: this.commerceId
    };
    this.commerceService.preResumeComputation(dto, this.messageService)
      .then(data => {
          if (!data.Success) {
              this.loading = false;
              this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
              return;
          }
          this.productComputation = data;
          this.loading = false;
      })
      .catch(err => {
          this.loading = false;
          throw err;
      });
  }
}
